const localization = {
    cannot_delete_default_language: '{{languageTag}} установлен как язык по умолчанию и не может быть удален.',
    invalid_translation_structure: 'Неверная структура данных. Пожалуйста, проверьте ввод и повторите попытку.',
};
export default localization;
